import PageBox from "PFComponents/box/page_box";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import Position from "./position";

const Positions = ({ data, mergeData, disabledItems, setDisabledItems, errors }) => {
  const { t } = useTranslation("changeRequests");

  if (!data || !data.positions?.length) {
    return false;
  }

  // positions don't have any ids and all other props are changable so you can only
  // refer to them by the index
  const makeHandleChangePosition = (index) => (change) => {
    if (change.main) {
      data.positions.forEach((pos) => (pos.main = false));
    }
    data.positions[index] = { ...data.positions[index], ...change };
    mergeData({ ...data, positions: [...data.positions] });
  };

  return (
    <PageBox style={{ padding: 20, marginBottom: 20 }} qaId="ChangeRequest.Positions">
      <h2 style={{ marginTop: 0 }}>{t("parts.positions")}</h2>
      {data.positions.map((position, index) => (
        <Position
          key={index}
          errors={errors?.find(({ ordinal }) => ordinal === position.ordinal)?.errors || {}}
          position={position}
          index={index}
          handleChangePosition={makeHandleChangePosition(index)}
          disabledItems={disabledItems}
          setDisabledItems={setDisabledItems}
        />
      ))}
    </PageBox>
  );
};

Positions.propTypes = {
  data: PropTypes.shape({
    positions: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired,
        summary: PropTypes.string.isRequired,
        start_date: PropTypes.string,
        end_date: PropTypes.string,
        duration: PropTypes.number,
        main: PropTypes.bool.isRequired
      })
    )
  }),
  mergeData: PropTypes.func.isRequired,
  disabledItems: PropTypes.shape({ positions: PropTypes.array }).isRequired,
  setDisabledItems: PropTypes.func.isRequired,
  errors: PropTypes.array
};

export default Positions;
